<!--  -->
<template>
  <section class="book-explantion-section">
    <div class="project-name-content">
      <div class="header-wrap">
        <span class="name-text title" :title="Train.trainingName"
          >项目名称：{{ Train.trainingName }}</span
        >
        <span
          class="name-edit label"
          @click="updateProject"
          v-if="userRole != 2"
          >修改</span
        >
      </div>
      <div class="teacher-info-wrap">
        <img :src="Train.photo ? photoBaseUrl + Train.photo : IconProfile" alt="" />
        <span :title="Train.createUserName">{{ Train.createUserName }}</span>
        <span :title="Train.roleName">{{ Train.roleName }}</span>
        <span :title="Train.orgsName">{{ Train.orgsName }}</span>
      </div>
      <div class="label-wrap">
        <span class="classify">
          <img :src="IconClassify" alt="" />
          <span> {{ trainingType }}</span>
        </span>
        <span class="create-time">
          <img :src="IconTime" alt="" />
          <span> {{ Train.createTime }}</span>
        </span>
      </div>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>
    <div class="explantion-list">
      <div class="item" v-for="(item, index) in pythonList" :key="index">
        <aside class="content">
          <div class="accountInfo-wrap">
            <img class="profile" :src="item.userPhoto ? photoBaseUrl + item.userPhoto : IconProfile" alt="" />
            <div class="accountInfo">
              <p>
                <span class="span-first" :title="item.userName">{{ item.userName }}</span>
                <span class="span-roleName" :title="item.roleName">{{ item.roleName }}</span>
              </p>
              <p>
                <span :title="item.organizationName">{{ item.organizationName }}</span>
              </p>
            </div>
          </div>
          <span class="create-time">
            <img :src="IconTime" alt="" />
            <span> {{ item.createTime }}</span>
          </span>
          <div
            :class="[
              'python-wrap',
              pythonDetails && showIndex === index ? 'show-all' : 'show-normal',
            ]"
          >
            <p class="python-text">
              <python-text :pythonBlocks="item.pythonBlocks" />
              <!-- <span>{{item.pythonBlocks}}</span> -->
            </p>
            <span class="label" @click="showDetails(item, index)">详情</span>
          </div>
          <span></span>
        </aside>
      </div>
    </div>

    <div
      class="publish-explantion-wrap"
      v-if="userRole === 2"
      @click="publishNewExplantion"
    >
      <img class="icon-project" :src="IconPublish" />
      <span class="text">发布新的项目解法</span>
    </div>

    <div class="popup-list">
      <!-- 保存并提交 -->
      <gat-popup
        :class="['popup-submit-save', popupActive === 'update' ? 'on' : 'off']"
        :title="'实训项目修改'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="confirmUpdate"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            ref="submitProject"
            :model="Train"
            label-width="100px"
          >
            <el-form-item label="项目名称：">
              <el-input
                placeholder="请输入项目名称"
                v-model.trim="Train.trainingName"
                maxlength="25"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="项目描述：">
              <el-input
                v-model.trim="Train.trainingContent"
                type="textarea"
                placeholder="请输入项目描述"
                :rows="10"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
  </section>
</template>

<script>
import bus from '@/utils/bus'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import COMMON from '@/axios/common/common.js'
import GatPopup from '@/components/common/GatPopup'
import { mapGetters } from 'vuex'
export default {
  name: 'aiBookExplantion',
  //import引入的组件需要注入到对象中才能使用
  components: {
    GatPopup,
    // 局部函数式组件
    'python-text': {
      props: {
        pythonBlocks: null,
      },
      computed: {},
      render: function(createElement) {
        let pythonBlocks = this.pythonBlocks,
          arr
        if (!pythonBlocks) return null
        arr = pythonBlocks.split(/\n/g)
        if (arr && arr.length) {
          return createElement(
            'ul',
            arr.map(function(item) {
              return createElement('li', {
                style: {
                  fontSize: '14px',
                  align: 'middle',
                  padding: '5px 0',
                  width: '100%',
                  overflow: 'hidden',
                },

                domProps: {
                  title: item,
                  innerHTML: item, //文本
                },
              })
            })
          )
        } else {
          return null
        }
      },
    },
  },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 创建人ID
    createBy: {
      type: String,
      default: null,
    },
    // 实训ID
    Train: {
      type: Object,
      default() {
        return { taskUrl: '', guidanceUrl: '' }
      },
    },
    //编辑器方式
    editorMode: {
      type: String,
      delete: '',
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      pythonList: [],
      popupActive: '',
      pythonDetails: false,
      showIndex: null,
      IconTime: require('@/assets/images/ai-editor/icon-time.png'),
      IconProfile: require('@/assets/images/ai-editor/profile03.png'),
      IconPublish: require('@/assets/images/ai-editor/publish.png'),
      IconClassify: require('@/assets/images/ai-editor/icon-classify.png'),
    }
  },
  filters: {
    // splitName: val => {
    //   let text;
    //   if (val && val.length > 8) {
    //     text = val.substring(0, 8) + "...";
    //   } else {
    //     text = val;
    //   }
    //   return text;
    // }
    formatText(val) {
      let text, temp
      if (val) {
        // temp = eval(val);
        text = val.replace(/\n/g, '<br>')
        // let text = val.replace((/\n|\t)/g, "<br>");
      }
      console.log(text)
      return text
    },
  },
  //监控data中的数据变化
  watch: {},
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'userRole']),
    trainingType() {
      let type = this.Train.type,
        val
      val =
        type == 1
          ? '算法编程应用'
          : type == 2
          ? '智能硬件应用'
          : type == 3
          ? '数据标注应用'
          : '行业创研应用'
      return val
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let self = this
    bus.$on('getProjectExplanation', () => {
      self.getProjectExplanation()
    })
    self.getProjectExplanation()
  },
  mounted() {},
  beforeDestroy() {
    bus.$off('getProjectExplanation')
  },
  methods: {
    /**
     * 获取项目解法  @data  trainingId
     */
    async getProjectExplanation() {
      let data = {
        trainingId: this.trainingId,
        createBy: this.createBy,
      }
      let res = await PROJECTS.getProjectExplanation(data)
      if (res && res.isSuccess) {
        let pythonList = res.data
        this.pythonList = pythonList
      }
    },
    /**
     *
     *
     * 项目修改处理方法
     * */
    updateProject() {
      this.popupActive = 'update'
    },
    async confirmUpdate() {
      let { trainingName, trainingContent } = this.Train
      let { trainingId } = this
      let data = { trainingId, trainingName, trainingContent }
      let res = await PROJECTS.updateTraining(data)
      if (res && res.isSuccess) {
        this.$emit('getTrainingByTrainingId') //父组件重新获取项目信息
        this.$message({
          message: '修改成功！',
          type: 'success',
          duration: 2000,
        })
      } else {
        this.$message({
          message: '修改失败！',
          type: 'error',
          duration: 2000,
        })
      }
      this.popupActive = ''
    },
    showDetails(item, index) {
      let xmlText
      this.pythonDetails = !this.pythonDetails
      this.showIndex = index
      if (this.editorMode == 'python') {
        xmlText = item.pythonBlocks
      } else {
        xmlText = item.buildingBlocks
        bus.$emit('changeWorkspace', true) //展现积木模式;
      }
      bus.$emit('textToWorkspace', xmlText) //调用BlocklyEditer.vue工作台生成积木方法
    },
    //发布新的项目解法
    async publishNewExplantion() {
      let data = {
        trainingId: this.trainingId,
      }
      let res = await PROJECTS.releaseProjectExplanation(data)
      this.getProjectExplanation()
      if (res && res.isSuccess) {
        this.$message.success(res.returnMsg)
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    cancelPopup() {
      this.popupActive = ''
    },
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.book-explantion-section {
  width: auto;
  height: 100%;
  padding: 0px 20px;
  color: #fefeff;
  .title {
    color: #fefeff;
    font-size: 16px;
    font-family: 'MicrosoftYaHei-Bold';
  }
  .label {
    font-size: 14px;
    color: #4c88ff;
    cursor: pointer;
    margin-left: 12px;
  }
  .project-name-content {
    width: 100%;
    .header-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      .name-text {
        flex: 1;
        color: #fefeff;
        font-size: 16px;
        font-family: 'MicrosoftYaHei-Bold';
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .teacher-info-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: rgba(153, 153, 153, 1);
      img {
        width: 16px;
        height: 16px;
        border-radius: 8px;
      }
      span {
        max-width: 65px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:last-child {
          max-width: 100%;
          flex: 1;
        }
      }
    }
    .label-wrap {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 20px;

      font-size: 13px;
      color: #999;
      .classify {
        span {
          opacity: 0.6;
          margin-left: 8px;
        }
      }
      .create-time {
        margin-left: 28px;
        span {
          opacity: 0.6;
          margin-left: 8px;
        }
      }
    }
    .el-divider {
      background-color: #253a76;
    }
  }
  .explantion-list {
    width: 100%;
    // max-height: calc(100% - 370px);
    max-height: calc(100vh - 380px);
    overflow-x: hidden;
    overflow-y: auto;

    /* 设置滚动条的样式 */
    &::-webkit-scrollbar {
      width: 5px;
    }
    /* 滚动槽 */
    &::-webkit-scrollbar-track {
      box-shadow: inset006pxrgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
      border-radius: 5px;
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #4c88ff;
      box-shadow: inset006pxrgba(0, 0, 0, 0.5);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }
    &::-webkit-scrollbar-thumb:window-inactive {
      background: rgba(76, 136, 255, 0.5);
    }
    .item {
      width: 100%;
      display: flex;
      justify-content: start;
      border-bottom: 1px solid #253a76;
      .content {
        width: 100%;
        // width: calc(100% - 50px);
        font-size: 14px;
        .accountInfo-wrap {
          width: 360px;
          color: #7f95d9;
          display: flex;
          box-sizing: border-box;
          .profile {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin-right: 10px;
          }
          .accountInfo {
            width: 310px;
            display: flex;
            flex-direction: column;
            p {
              flex: 1;
              display: flex;
              // justify-content: space-between;
              span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .span-first {
                max-width: 220px;
              }
              .span-roleName {
                margin-left: 20px;
              }
            }
          }
        }
        .python-wrap {
          display: flex;
          justify-content: space-between;
          margin: 20px 0;
          overflow: hidden;
          transition: all 0.5s;
          &.show-normal {
            max-height: 100px;
            max-height: auto;
            transition: all 0.5s;
          }
          &.show-all {
            // display: ;
            max-height: auto;
            transition: all 0.5s;
          }
          .python-text {
            width: 85%;
            // max-height: 114px;
            height: auto;
            color: #d0dcff;
            font-size: 14;
            margin-bottom: 30px;
          }
        }

        .create-time {
          display: inline-block;
          margin-top: 17px;
          color: rgba(153, 153, 153, 0.6);
          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
}
.popup-list {
  .popup-submit-save {
    &.off {
      display: none;
    }
    &.on {
      display: inline-block;
    }
    &::v-deep .popup-inner {
      width: 580px;
      height: 100%;
      max-height: 48%;
      .popup-content {
        margin-top: 20px;
        .el-form {
          width: 96%;
          .el-form-item {
            margin-bottom: 20px;
          }
        }
        .score-text {
          margin-top: 20px;
        }
      }
    }
  }
}
.publish-explantion-wrap {
  display: flex;
  justify-content: center;
  width: auto;
  padding: 5px 10px;
  position: absolute;
  z-index: 101;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(21, 51, 108, 0.49);
  border-radius: 18px;
  font-size: 15px;
  color: #fff;
  cursor: pointer;
  img {
    margin-right: 5px;
  }
}
</style>
